export const DATO_MAX_FIRST = 100
export const DEFAULT_INITIAL_LOAD_NUM_RECORDS = 30
export const DEFAULT_INITIAL_LOAD_NUM_POSTS = 30
export const DEFAULT_INITIAL_LOAD_NUM_SUPPLIERS = 16
export const GEOLOCATION_DEFAULT_RADIUS = 50
